import {once} from 'ramda';
import {setRootCustomProperty} from '~/dom-utils';

const CSS_PROPERTY = '--ua-scroll-size';

function getScrollbarWidth() {
    const outer = document.createElement('div');
    const inner = document.createElement('div');

    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.appendChild(inner);
    document.body.appendChild(outer);

    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    setRootCustomProperty(CSS_PROPERTY, `${scrollbarWidth}px`);
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

export default once(getScrollbarWidth);
